import React, { useEffect, useState } from 'react';
import { Result, Button, Card, Space, Typography, Divider, message } from 'antd';
import { ClockCircleOutlined, HomeOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Order } from '../../types';
import { formatAmount, formatDateTime } from '../../utils';

const { Text } = Typography;

const PaymentProcessing: React.FC = () => {
  const navigate = useNavigate();

  const [order, setOrder] = useState<Order | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<string>('');

  useEffect(() => {
    const storedOrder = sessionStorage.getItem('currentOrder');
    const storedPaymentMethod = sessionStorage.getItem('selectedPaymentMethod');

    if (storedOrder && storedPaymentMethod) {
      setOrder(JSON.parse(storedOrder));
      setPaymentMethod(storedPaymentMethod);
    } else {
      message.error('支付信息丢失，请重新发起支付');
      // Optionally close the window or navigate to a specific error page
      // window.close(); 
    }
  }, []);

  if (!order) {
    return (
      <div className="empty-container">
        <Text>支付信息丢失，请联系客服</Text>
        <Button 
          type="primary" 
          onClick={() => window.close()} // Close the window if order is lost
          style={{ marginTop: 16 }}
        >
          关闭页面
        </Button>
      </div>
    );
  }

  const handleBackToQRCode = () => {
    navigate('/payment-process/qrcode-auth', {
      state: { order, paymentMethod }
    });
  };


  const handleBackHome = () => {
    // 新标签页打开订单中心
    window.open('about:blank', '_blank');
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '40px 20px' }}>
      <Result
        icon={<ClockCircleOutlined style={{ color: '#faad14' }} />}
        title="支付处理中"
        subTitle="系统正在处理您的支付请求，请耐心等待"
        extra={[
          <Button type="primary" key="qrcode" onClick={handleBackToQRCode} icon={<QrcodeOutlined />} size="large" style={{ minWidth: 140 }}>
            返回扫码授权
          </Button>,
          <Button key="home" icon={<HomeOutlined />} onClick={handleBackHome} size="large" style={{ minWidth: 140 }}>
            返回订单中心
          </Button>,
        ]}
      />



      {/* 交易详情卡片 */}
      <Card 
        title="交易详情" 
        style={{ marginTop: 24 }}
        headStyle={{ background: '#fafafa', fontWeight: 600 }}
      >
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">订单号：</Text>
            <Text strong>{order.order_no}</Text>
          </div>
          

          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">付款方：</Text>
            <Text>{order.payer_name}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">收款方：</Text>
            <Text>{order.payee_name}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">支付方式：</Text>
            <Text>交e保支付</Text>
          </div>
          
          <Divider />
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">支付金额：</Text>
            <Text 
              strong 
              style={{ 
                fontSize: 18, 
                color: '#faad14',
                fontFamily: 'monospace'
              }}
            >
              ¥{formatAmount(order.amount)}
            </Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">提交时间：</Text>
            <Text>{formatDateTime(new Date().toISOString())}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">当前状态：</Text>
            <Text style={{ color: '#faad14' }}>
              处理中
            </Text>
          </div>
        </Space>
      </Card>

      {/* 处理提示 */}
      <Card 
        size="small" 
        style={{ 
          marginTop: 16, 
          background: '#fffbe6', 
          border: '1px solid #ffe58f' 
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            支付处理通常需要1-3分钟，请勿关闭页面或重复提交
          </Text>
        </div>
      </Card>


    </div>
  );
};

export default PaymentProcessing;